import NavbarTop from "../ui_components/navbar_top";
import { useParams } from 'react-router-dom';
import React, { useEffect, useState, useMemo } from 'react';
import Editor from '@monaco-editor/react';
import classNames from 'classnames';
import { JAVA, ALL_LANGUAGES, PYTHON, errorMsg, handleCtrlSave, homeUrl, success, isBlankOrNullString } from "../utils/common_utils";
import { getAuth, getCurrrentLanguage, getUIState, isLoggedIn, isValidUser, saveCurrentLanguage, saveUser } from "../login/auth_utils";
import { getJsonDataPostRequest, getTextFileAsString, uploadStringToS3, uploadTextToS3 } from "../utils/network_utils";
import { extractQuestionId, isFailedTestExecutionStatus, isTestRunning, testExecutionStatusToString } from "./question_utils";
import IndefiniteProgressBar from "../ui_components/indefinite_progress_bar";
import LoginModal from "../login/email_login_modal";
import FontSizeChanger from "../ui_components/font_size_changer";
import { CheckRunIcon, LeftIcon, SaveIcon, PlayIcon, ResetIcon } from "../ui_components/common_icons";
import { VisitPremiumSection } from "../premium/premium_discounts";
import { SelectLanguageDropdown } from "./select_language_dropdown";
import { BuyPremiumMotivationQuestionsPage, BuyPremiumMotivationSmall1 } from "../premium/buy_premium_motivation";
import { BRR } from "../ui_components/common_ui_components";
import { LinkUIBlueBold } from "../ui_components/common_links";
import { AIInterviewUI } from "./ai_interview_link";

function QuestionCodeSubmission({question}) {
//const QuestionCodeSubmission = () => {
  const [code, setCode] = useState('');
  const [output, setOutput] = useState('');
  const [loading, setLoading] = useState(false);
  const[language, setLanguage] = useState(getCurrrentLanguage()); 
  const[error, setError] = useState('')
  const[message, setMessage] = useState('')
  const [metadata, setMetadata] = useState({})
  const[loggedIn, setLogin]= useState(false)
  const [aiMockId, setAiMockId]= useState(-1)
  const uiState=getUIState()
  const availableLanguages = ALL_LANGUAGES.filter(
    str=> isBlankOrNullString(question.languages) 
    || question.languages.indexOf(str)>=0)
    
  //console.log(question)  
  const [fontSize, setFontSize] = useState(16);
  const editorOptions = useMemo(() => ({
    wordWrap: 'on',
    fontSize,
    fontFamily: 'Monaco',
    minimap: { enabled: false },
    overviewRulerLanes: 1,
    autoIndent: true,
    hideCursorInOverviewRuler: false,
  }), [fontSize]);

  /** run id will be used for rejecting older run code requests when a new one comes in */
  //const [runId, setRunId] = useState(0)
  var runId=0
  const  { questionId }  = useParams();
  
  console.log("question id in question code submission : "+questionId)
  const auth = getAuth()

  function languageChanged(newLanguage){
    // first save then update
    handleSave(() => {
    console.log("new language is "+newLanguage)
    if(isBlankOrNullString(newLanguage) || question.languages.indexOf(newLanguage)<0) return
    setLanguage(newLanguage)
    saveCurrentLanguage(newLanguage)
    fetchSubmissionMetadata({currentLanguage : newLanguage , createNewSubmission:false})
  });
  }

  function resetMessages(){
    setMessage("")
    setError("")
    setOutput("")
  }

  const handleResetDefault = async () => {
    // Make API request to run code and get output
    resetMessages()
    setMessage("going to reset code to default ...")
    fetchSubmissionMetadata({currentLanguage : language, createNewSubmission:true})
  
    //fetchSubmissionMetadata(true)
  }
  
  const handleSave = async (callback=() => {}) => {
    //function handleSave(){
    // Make API request to run code and get output
    resetMessages()
    setMessage("Saving code ...")
    setLoading(true)
    console.log("saving code")
    console.log(metadata.presignedGetUrlCode)
    //console.log(metadata.presignedPutUrlCode)
   // uploadStringToS3(metadata.presignedPutUrlCode, code, "Solution.txt", function(data){
    uploadTextToS3(code, metadata.presignedPutUrlCode, function(data){
      setLoading(false)
      setMessage("code saved ...")
      //console.log(" data file upload : "+data)
      if(!success(data.status)){
         let msg = data.message || "error occurred in saving file... please try again";
         setError(msg) // setOutput(msg)
         setMessage("")
      }
      //else if(callback) 
      if(success(data.status) && typeof callback === 'function')  callback();
    })
  }

  const handleRunSampleTests = async () => {
    submitRunRequest(0)
  };

  const handleSubmit = async () => {
    submitRunRequest(1)
  };

  function submitRunRequest(executionType = 0){
    // save the code before execution
    resetMessages()
    setLoading(true)
    let exId = extractQuestionId(questionId, "0")
    setMessage("saving code ..") // setOutput("saving code")
    if(!metadata.presignedPutUrlCode)
      setError("Settings not fetched properly. Please refresh page <br /> or Logout and Login again")
    uploadTextToS3(code, metadata.presignedPutUrlCode, function(data){
    setMessage("")
    if(!success(data.status)){ 
      setOutput(data.message || "error occurred in saving file... please try again")
      setLoading(false)
    }
    else{
      //console.log(metadata.presignedGetUrlCode)
      setOutput("Code saved .. going to submit for test execution")
      // if save is successful then submit code for execution 
      let url = homeUrl()+"questionsApi/submitCodeForTesting"
      let submissionData = { auth:auth, questionId: exId,
      submissionId: metadata.submissionId, executionType: executionType }
      getJsonDataPostRequest(url, submissionData, function(response){
        console.log("code submitted "+JSON.stringify(response))
        if(success(response.status)){
          setOutput("Code submitted for test execution ... \n It can take 1 or 2 minutes to run all tests ...")
          runId=response.runId //setRunId(response.runId)
    // if code is submitted for execution then keep fetching status until run finishes/error/timeout or a new request comes. 
          updateRunStatus(runId, executionType)
        }
        else{
          setLoading(false)
          let msg = response?.message || "Error occurred in submitting code for test execution, please try again."
            setError(msg) // setOutput(msg) 
            console.log(msg)
        }
    })  
      }
      
    })  
    
  }

  /** first min 4 sec, after 1st min 6 sec, after 2nd min 10 sec */
  const computeDelay = (elapsedSec) => {
  if (elapsedSec < 60) return 4000;     // first minute -> 4s
  if (elapsedSec < 120) return 6000;    // second minute -> 6s
  return 10000;                          //10 sec after that
};


 /**
  * used to fetch execution status every 3 sec and show as output
  */
  function updateRunStatus(currentRunId, executionType){
    console.log(" going to start fetching test execution status, loading "+loading)
    var startTime = new Date().getTime()
    let exId = extractQuestionId(questionId, "0")
  const intervalId = setInterval(() => {
      console.log("running interval "+intervalId+" runId "+runId+" current run id "+currentRunId)
    //  console.log("new Date().time "+new Date().time+" , Date.now() "+Date.now()+
    //  " new Date().getTime() "+new Date().getTime());
      

      // write code to fetch submissions and end timer based on that  
    let url = homeUrl()+"questionsApi/getSubmissionStatus"
    let data = { auth:auth, questionId: exId,
      submissionId: metadata.submissionId, executionType: executionType, runId: runId }

    getJsonDataPostRequest(url, data, function(response){
      if(runId!=currentRunId) {
        clearInterval(intervalId)
        return
      }
      console.log("code execution status response : \n "+response.data.executionStatus+": "+response.data.executionMessage)
      if(success(response.status)){
        if(isFailedTestExecutionStatus(response.executionStatus))
         setOutput(testExecutionStatusToString(
          response.data, language))
        else setOutput(testExecutionStatusToString(
          response.data, language) || (" <div class='italic text-blue-600'> still fetching ... </div>\n it can take 30 seconds to a few minutes")) 
        // unless test execution has not yet started or is still active i.e test execution has ended in success or failure then stop the interval  
        if(!isTestRunning(response.data.executionStatus)) {
          console.log("test not running anymore")  
          setLoading(false)
          clearInterval(intervalId); 
        }
      }
      else{
        let msg = response?.message || "Error occurred in fetching details."
          setError(msg) // setOutput(msg) 
      }
      
  })

  // fetch status till 3 minutes, every 5 sec 
    // it will stop fetching updates after 180 seconds . 180 seconds timeout
    const elapsedTime = new Date().getTime()-startTime
  //  const delay = computeDelay(elapsedTime)
    console.log("elapsed time in seconds "+elapsedTime/1000)
    if (elapsedTime>180*1000) {
      // ending the fetch
      setLoading(false)
      clearInterval(intervalId);
      console.log("stopped interval "+intervalId)
    }
    // keeping constant delay of 5 sec
    }, 5000,3000); // second 3000 ms is initial delay after which interval starts, needed to add this because initial reset to test submission data in dynamodb is eventually consistent, so needed to read after a few seconds.
  }

 function fetchSubmissionMetadata({currentLanguage = language, createNewSubmission = false}){
    if(!auth|| !auth.userId||auth.userId<0){
    setError("Please login and try again")
    return
  }
  setLoading(true)
  resetMessages()
  let exId = extractQuestionId(questionId, "0")
  let data = {
      auth:auth,
      questionId: exId,
      language: currentLanguage,
      createNewSubmission: createNewSubmission
  }

  console.log("fetching the solution code metadata "+JSON.stringify(data));
  let metadataUrl = homeUrl()+"questionsApi/getQuestionSubmissionMetadata"

  getJsonDataPostRequest(metadataUrl, data, function(data){
    if(success(data.status)){
      if(isValidUser(data.user)) saveUser(data.user)
      // using else because normal variable will forget values
      setMetadata(data.metadata)
      console.log("submission id "+data.metadata.submissionId+" create new submission "+createNewSubmission)
      
      // console.log("presigned get url :"+data.metadata.presignedGetUrlCode+",\n\n metadata:  "+JSON.stringify(data.metadata))
      getTextFileAsString(data.metadata.presignedGetUrlCode, 
        function(codeText){
          setLoading(false)
         // console.log("code text received ::\n "+codeText)
          if(codeText.length>0){
            setCode(codeText)  
            if(createNewSubmission)
              setMessage("reset to default code done ...")
            
          }
          else {
            setError("Some error occurred in fetching code \n please try again or reset code")
            setCode("// no code found, maybe try to fetch again")
          }
        })
    }
    else{
      setError(data.message || "Error in fetching code, please try again")
      setLoading(false)
    }
      //console.log("response received")
      //console.log(data);
  });
  }

  const handleKeyDown = (e) => {
    // handling ctrl+s
    handleCtrlSave(e, function(){
      console.log("\n ignoring ctrl+s click because handling it was giving error,\n and ignoring is better than accidently opening a save page dialog.")
    });
  };

// loading metadata and code 
useEffect(() => {
  setLogin(isLoggedIn())
  console.log("basic question metadata for submission "+JSON.stringify(question))
  if(question && question.aiMockQuestionId && question.aiMockQuestionId>0) 
      setAiMockId(question.aiMockQuestionId)
  console.log("question is available in these languages "+question.languages)
  console.log("available languages "+JSON.stringify(availableLanguages))
  var lang=language
  if(isBlankOrNullString(language) || question.languages.indexOf(language)<0){
    lang=availableLanguages[0]
    setLanguage(lang)
    saveCurrentLanguage(lang)
  }
  fetchSubmissionMetadata({currentLanguage : lang, createNewSubmission:false})
  // listening to key clicks
  document.addEventListener('keydown', handleKeyDown);
  return () => {
    document.removeEventListener('keydown', handleKeyDown);
  };
   
}, []); // empty bracket means there are no dependencies which will make useEffect run only once and not re run again and again

  return (
  <div className="w-full px-2 md:px-3">
  { uiState==0 &&
      <div className="
        mx-auto mt-8 flex min-h-[360px] max-w-xl flex-col items-center justify-center
        px-4 py-8 text-center md:mt-16
      ">
        <div className="text-lg font-medium leading-8 text-slate-700 md:text-xl"> 
        <BRR /> <br />
        
            You need to be logged in to test and submit code <BRR /> <br />
            <div className="mt-4">
              <LoginModal />
            </div>
            <br /> <br /> <br /> <br />
           { false &&
            <AIInterviewUI aiMockId={aiMockId} question={question} />
           }
        </div>
        
      </div>
  } 

   {question.type==1 && (uiState==1||uiState==2) &&
   <div className="flex min-h-[360px] flex-col items-center justify-center px-3 py-5">
    
   <BuyPremiumMotivationSmall1 />
   { false && 
   <AIInterviewUI aiMockId={aiMockId} question={question} />
  }
   </div>
   }  

{((question.type==0 && uiState!=0) || uiState==3) &&
<div className="flex min-h-screen flex-col bg-white"> 
<div className="
  mb-2 flex w-full my-2  flex-row flex-wrap items-center justify-between gap-x-8 gap-y-1 px-1 py-0
">
  <div className="flex h-9 min-w-[210px] flex-shrink-0 items-center">
    {
      <SelectLanguageDropdown
        language={language}
        availableLanguages={availableLanguages}
        onLanguageChange={languageChanged}
      />
    } 
  </div>

  <div className="flex h-9 flex-shrink-0 items-center">
    <FontSizeChanger fontSize={fontSize} setFontSize={setFontSize} />
  </div>

  <div className="flex h-9 min-w-[170px] flex-shrink-0 items-center justify-end gap-3">
    { loading && 
      <span className="inline-flex h-8 w-24 items-center">
        <IndefiniteProgressBar />
      </span>  
    }

    <button
      type="button"
      className="
        inline-flex h-8 items-center justify-center gap-1.5 rounded-full
        bg-slate-100 px-3 text-xs font-semibold text-slate-600
        shadow-sm ring-1 ring-slate-200 transition
        hover:bg-slate-800 hover:text-white hover:ring-slate-800
        focus:outline-none focus:ring-2 focus:ring-slate-300
      "
      onClick={handleResetDefault}
    >
      <ResetIcon className="h-3.5 w-3.5" />
      <span>Reset To Default Code</span>
    </button>
  </div>
  </div>

 {loggedIn && <div className="
    min-h-[430px] overflow-hidden rounded-xl bg-white shadow-sm ring-1 ring-slate-200
    md:h-[calc(100vh-230px)]
  "> 
    <Editor
     // height="450px"
      defaultLanguage={language}
      language={language}
      defaultValue="// Fetching code ... please wait .."
      value={code}
      onChange={setCode}
      options={editorOptions}
      /*
      {
        wordWrap: 'on',
        fontSize: fontSize,
        minimap: { enabled: false },
        overviewRulerLanes: 1,
        autoIndent: true,
        hideCursorInOverviewRuler: false,
      }
      */
    />
  </div>
}

    <div className="mt-2 pb-4"> 
    <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">   
    <div className="flex items-center gap-3">
    <span className="text-xl font-bold text-slate-900">Output:</span>  
    </div>
    <div className="flex flex-wrap items-center gap-2">    
      <button
        type="button"
        className="
          inline-flex items-center justify-center gap-2 rounded-full
          bg-slate-500 px-4 py-2 text-sm font-semibold text-white
          shadow-sm transition hover:bg-slate-700
        "
        onClick={handleSave}
      >
        <SaveIcon className="h-4 w-4" />
        <span>Save</span>
      </button> 

    <button
      type="button"
      className="
        inline-flex items-center justify-center gap-2 rounded-full
        bg-indigo-500 px-4 py-2 text-sm font-semibold text-white
        shadow-sm transition hover:bg-indigo-600
        disabled:cursor-not-allowed disabled:opacity-60
      " 
      onClick={handleRunSampleTests}
      disabled={loading}
    >
      <PlayIcon className="h-4 w-4" />
      <span>Run Sample Tests</span>
    </button> 

    <button
      type="button"
      className="
        inline-flex items-center justify-center gap-2 rounded-full
        bg-emerald-600 px-4 py-2 text-sm font-semibold text-white
        shadow-sm transition hover:bg-emerald-700
        disabled:cursor-not-allowed disabled:opacity-60
      " 
      onClick={handleSubmit}
      disabled={loading}
    >
      <CheckRunIcon className="h-4 w-4" />
      <span>Run All Tests</span>
    </button> 
    </div> 
    </div> 

    {(error || message || output) &&
    <div className="mb-12 mt-2 rounded-xl bg-slate-50 p-3"> 
      <div>
      { error &&
      <div className="rounded-lg bg-red-50 px-3 py-2 text-center text-lg font-bold leading-7 text-red-700"
      dangerouslySetInnerHTML={{ __html: error }} />
      }
      {message &&
      <div className="rounded-lg bg-indigo-50 px-3 py-2 leading-7 text-indigo-700"
      dangerouslySetInnerHTML={{ __html: message }} />
      } 
      </div>

      <div className="prose mt-2 max-w-none whitespace-pre-wrap rounded-lg bg-white px-3 py-2 leading-6 text-slate-900"
      dangerouslySetInnerHTML={{ __html: output }} />
    
    </div>
  }
    {false && !output && aiMockId>0 &&
    <div>
      <br />
      <AIInterviewUI aiMockId={aiMockId} question={question} />
    </div>  
    }
    
    { false && !output && aiMockId>0 &&
      <div className="ml-4 text-sm leading-8 text-gray-600">
       { false &&
        <span>In case, you are looking to practice this question through discussion. 
         <br /> </span>
      }
         Also try our AI Mock Interviewer.  
        <LinkUIBlueBold 
        url={`https://mockgym.com/question/${question.aiMockQuestionId}`} />
        <br />
        
        { // DSA and DSA Sets
        question && (question.questionCategory==2 || question.questionCategory==4) &&
          <div>
          It will discuss this question with you in a standard MAANG interview format: <br /> 
        &nbsp; - Asks counter questions on DS & Algo you used vs alternate options. <br />
        &nbsp; - Will discuss space and time complexity and trade offs in your solution. <br />
        &nbsp; - Will give final assessment on how you performed.
        </div>
      }
      
      { // LLD and HLD
      question && (question.questionCategory==0 || question.questionCategory==1) &&
          <div>
            
           It will train you to cover overall low level design of this question within 
           45-60 minutes of interview round.  <br /> 
        &nbsp; - Will teach you which core functionalities to discuss 
        during interview while leaving the rest.  <br /> 
        &nbsp; - Asks counter questions on your choice of design patterns, 
        class structure etc. <br />
        &nbsp; - Gives pinpointed strengths and gaps final report 
        on how you performed.  <br /> 
        &nbsp; - Follows standard MAANG interview format for Low Level Design
        </div>
      }
        <br />
        
        </div>
    }

   
    </div>
       
  </div>
  }
  </div>  
    
  );
  
}

 export default QuestionCodeSubmission;